import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { signOutAuth } from "../../actions/globalAction";
import { turnSocketOff, ssoLogout, iAmLive } from "../../api";
import { clearTranslate, showOriginalText } from "../MainContainer/gtUtils";

class Logout extends Component {
    componentDidMount() {
        // window.localStorage.setItem("logged_out", "logout" + Math.random());
        // Disconnect the sockets
        let token = localStorage.getItem("token");
        turnSocketOff(1);
        turnSocketOff(2);

        // Clear Google Translate
        clearTranslate();
        showOriginalText();
        this.props.signOutAuth(token).then(()=>{
            iAmLive("logout").then(() => {
                if (sessionStorage.getItem("ssoLogin") === "true") {
                    ssoLogout();
                } else {
                    let isSessionTimedOut = sessionStorage.getItem("isSessionTimedOut");
                    localStorage.clear();
                    sessionStorage.clear();
                    if (isSessionTimedOut != null || isSessionTimedOut != undefined) sessionStorage.setItem("isSessionTimedOut", isSessionTimedOut);
                    window.location.href = "/";
                }
            });
        });
    }
    render() {
        return <Redirect to="/" />;
    }
}

const mapDispatchToProps = (dispatch) => ({
    signOutAuth: (data) => dispatch(signOutAuth(data)),
});

export default connect(null, mapDispatchToProps)(Logout);
